<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card>
                <v-toolbar dark color="green">
                    <v-btn icon dark @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>HISTORIA CLINICA</v-toolbar-title>
                    <v-spacer></v-spacer>
                    N° {{ codigo }}
                </v-toolbar>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="4" sm="2" md="2">
                            <h6>Legajo: {{ legajo }}</h6>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <h6>Nombre: {{ nombre }}</h6>
                        </v-col>
                        <v-col cols="4" sm="3" md="3">
                            <h6>Fecha Nacimiento: {{ fnacimiento }}</h6>
                        </v-col>
                        <v-col cols="4" sm="3" md="3">
                            <v-text-field requiered :rules="requiredRules" label="Fecha" dense v-model="fecha">
                            </v-text-field>
                        </v-col>
                        <!-- <v-col cols="4" sm="2" md="2">
                <h6>DNI: {{ dni }}</h6>
              </v-col> -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-textarea label="Descripción" dense v-model="histclinica">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="4" md="4">
                            <v-text-field label="Días de Baja" dense v-model="dias">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <v-select dense v-model="lugar" :items="listadolugar" label="Lugar" item-text="nombre"
                                item-value="codigo"></v-select>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <v-select dense v-model="tipo" :items="listadotipo" label="Tipo" item-text="nombre"
                                item-value="codigo"></v-select>
                        </v-col>

                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="4" md="4">
                            <v-text-field label="Fecha de Baja" dense v-model="baja">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <v-text-field label="Fecha de Alta" dense v-model="alta">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <v-text-field label="Fecha de Control" dense v-model="control">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card color="green" dark tile>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.stop="guardarDatospersonal">Guardar</v-btn>

                    <v-btn color="error" @click.stop="show = false">Salir</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import axios from "../../../src/axios-auth";
import moment from "moment";

export default {
    data: (vm) => ({
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        legajo: "",
        dni: "",
        nombre: "",
        fnacimiento: "",
        fecha: moment().format("DD/MM/YYYY"),
        histclinica: "",
        dias: "0",
        baja: moment().format("DD/MM/YYYY"),
        alta: "",
        control: "",
        lugar: "",
        tipo: "",
        listadolugar: [{ nombre: "Consultorio ICSSA", codigo: "C" },
        { nombre: "Domicilio", codigo: "D" },
        { nombre: "Clínica", codigo: "S" },
        { nombre: "ART", codigo: "A" },],
        listadotipo: [{ nombre: "Enfermedad Inculpable", codigo: "E" },
        { nombre: "Enfermedad Profesional", codigo: "P" },
        { nombre: "Accidente de Trabajo", codigo: "AT" },
        { nombre: "Accidente In Itinere", codigo: "AI" },
        { nombre: "Otro", codigo: "O" },],
        codigo: "",
        valid: false,
        deshabilitar: false,
        lazy: false,
    }),
    watch: {
        alta(val) {
            if (this.alta.length == 10 && this.baja.length == 10) {
                this.dias = moment(this.alta, "DD/MM/YYYY").diff(moment(this.baja, "DD/MM/YYYY"), "days")
            } else {
                this.dias = "0";
            }
        },
    },
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.buscarHistClinica();
                    return this.visible;
                }
            },
            set(value) {
                if (!value) {
                    this.$refs.form.resetValidation();
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    props: ["visible", "leg", "id"],
    methods: {
        buscarHistClinica() {

            console.log("HC" + this.leg)
            if (this.leg != null) {

                let self = this;
                axios
                    .get("/Medico/HistClinica?", {
                        params: {
                            legajo: self.leg,
                        },
                    })
                    .then((response) => {
                        self.legajo = response.data.legajo;
                        self.nombre = response.data.nombre;
                        self.fnacimiento = moment(response.data.fechanacimiento).format("DD/MM/YYYY");
                        self.codigo = response.data.codhistclin;
                    })
                    .catch((error) => {
                        //self.listadotrazabilidad = [];
                        console.log(error);
                    });
                console.log("HC ")
            }
        },
        vaciarModels() {
            this.legajo = "";
            this.dni = "";
            this.nombre = "";
            this.fnacimiento = "";
            this.fecha = moment().format("DD/MM/YYYY");
            this.histclinica = "";
            this.dias = "0";
            this.baja = moment().format("DD/MM/YYYY");
            this.alta = "";
            this.control = "";
            this.lugar = "";
            this.tipo = "";
        },

        guardarDatospersonal() {
            this.$swal({
                title: "Guardar Historia Clínica",
                text: "¿Desea guardar los datos de la HC?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        legajo: this.legajo,
                        alta: this.alta,
                        baja: this.baja,
                        control: this.control,
                        histClinica: this.histclinica,
                        dias: this.dias,
                        lugar: this.lugar,
                        tipo: this.tipo,
                        fecha: this.fecha,
                        codhistclin: this.codigo,

                    };

                    let self = this;
                    axios
                        .post("/Medico/GuardarHC", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Datos guardados con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                    //this.$swal('Cancelled', 'Your file is still intact', 'info')
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>